import React, { FC, useState } from "react";
import { Button, Table, message, Modal, Input } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useSalesDetailModel } from "../salesDetailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { formatNum, formatInt } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { ISalesMaterialDetail, ISalesDetail } from "@/views/sales/salesTypes";
import { enquiryService } from "@/views/inquires/enquiry/enquiryService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addList,
        editList,
        editFormVal,
        addFormVal, addDesc, editDesc,
        updateList,
        removeMaterial,
        setMaterialDialog, getcurrencySymbol
    } = useSalesDetailModel(({ addList, editList, addDesc, editDesc }) => [addList, editList, addDesc, editDesc]);

    const tableList = mode === "edit" ? editList : addList;
    const formVal: ISalesDetail = mode === "edit" ? editFormVal : addFormVal;
    const desc = mode === "edit" ? editDesc : addDesc;
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    const columns = [
        {
            title: '序号',
            width: 45,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '商品编码',
            width: 160,
            fixed: "left",
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            fixed: "left",
            dataIndex: 'materialName',
        }, {
            title: '商品名称-英文',
            width: 160,
            fixed: "left",
            dataIndex: 'materialEname',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
        },
        // {
        //     title: '库存',
        //     width: 100,
        //     dataIndex: 'inventoryNum',
        // },
        {
            title: '*数量',
            width: 160,
            dataIndex: 'num',
            editable: true,
            // }, {
            //     title: '云湖销售单价',
            //     width: 160,
            //     dataIndex: 'salePrice',
            //     render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            //     editable: true,
            // }, {
            //     title: '云湖销售总价',
            //     width: 160,
            //     dataIndex: 'saleAmount',
            //     render: (text: any) => `￥${formatNum(text)}`,
        }, {
            title: '外贸单价',
            width: 160,
            dataIndex: 'tradePrice',
            render: (text: any) => text === "null" ? "" : `${getcurrencySymbol(mode)} ${formatNum(text)}`,
            editable: true,
        }, {
            title: '外贸总价',
            width: 160,
            dataIndex: 'tradeAmount',
            render: (text: any) => `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }, {
            title: '海关编码',
            width: 160,
            dataIndex: 'customsCode',
        }
    ];

    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        let { exchangeRate } = formVal; //汇率
        let dataSource = [...tableList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        let num: number = +formatInt(row.num);
        let salePrice: number = +formatNum(row.salePrice); //云湖销售单价
        //判断（数量||单价）有变动过 ？ 后面所有单价和总价按照公式重新计算一遍 ： 计算单个模块的
        if (+item.num !== num || +item.salePrice !== salePrice) {
            row.num = num;
            row.salePrice = salePrice;
            //云湖销售总价 = 数量 * 云湖销售单价
            row.saleAmount = +formatNum(num * salePrice);

            //外贸价格 = (云湖销售单价)人民币 / 汇率
            row.tradePrice = +formatNum(row.salePrice / +exchangeRate);
            row.tradeAmount = +formatNum(num * +row.tradePrice);

        } else {
            //外贸价格 = (云湖销售单价)人民币 / 汇率
            row.tradePrice = +formatNum(row.tradePrice);
            row.tradeAmount = +formatNum(num * +row.tradePrice);
        }

        dataSource.splice(index, 1, { ...item, ...row });
        updateList(mode, dataSource);
    }

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_ADD_M}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { setMaterialDialog(true) }}
            >新增</Button>
        </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DEL_M}> */}
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要删除的商品");
                    return;
                }
                removeMaterial(mode, selectedRowKeys)
            }}
        >删除</Button> */}
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DLOAD}> */}
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { }}
        >导入</Button> */}
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_EX}> */}
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { }}
        >导出</Button> */}
        {/* </YhAuth> */}

    </>
    const leftChildren = mode === 'edit' ? <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行排序");
                    return;
                }
                let number = "";
                Modal.confirm({
                    title: "请输入排序数字",
                    content: <>
                        <Input placeholder="请输入排序数字" onChange={(e) => { number = e.target.value }} />
                    </>,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            if (number && /^[+-]?\d*\.?\d*$/.test(number)) {
                                resolve(number);
                            } else {
                                message.warning("请输入排序数字");
                                reject('请输入排序数字');
                            }
                        }).then(async (res: any) => {
                            let { retData } = await enquiryService.saleOrderNum({
                                id: selectedRowKeys[0],
                                orderNum: +res
                            })
                            message.success("修改成功")
                        });
                    },
                    onCancel: () => { }
                })
            }}
        >修改顺位</Button>
    </> : <></>



    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        num: desc.numAll,
        tradeAmount: desc.tradeAmountAll,
        saleAmount: desc.saleAmountAll,
        tradePrice: "null",
        salePrice: "null",
    }

    return (
        <YhBox title={leftChildren} style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISalesMaterialDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys.filter(item => item !== "totalAmount") as string[]);
                    }
                }}
                // components={{
                //     body: {
                //         row: EditableRow,
                //         cell: EditableCell,
                //     },
                // }}
                // columns={newColumn as ColumnsType<any>}
                columns={columns as ColumnsType<any>}
                dataSource={tableList.length > 0 ? [...tableList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', }}
            />
        </YhBox>
    )
}